<template>
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <div class="card-title pt-3 px-3 d-flex justify-content-between">
            <div class="breadcrumb-left">
              <h4>Exams for this classroom</h4>
            </div>
          </div>
        </div>
        <div class="card-body">
          <div class="table-responsive">
            <v-skeleton-loader
                type="table-thead"
                v-if="examLoading"
            >
            </v-skeleton-loader>

            <v-skeleton-loader
                v-if="examLoading"
                type="table-row-divider@25"
            >
            </v-skeleton-loader>
            <table class="table" v-if="!examLoading">
              <thead>
                <tr class="px-3">
                  <th>Title</th>
                  <th>Date</th>
                  <th>Exam status</th>
                  <th>Result status</th>
                  <th class="pr-3 text-center">Action</th>
                </tr>
              </thead>
              <tbody>
              <tr v-show="assigned_exams.length > 0" v-for="(item,index) in assigned_exams" :key="index">
                <td>
                  <span class="font-weight-medium">
                     {{ item.title }}
                  </span>&nbsp;
                  <i class="fas fa-circle"
                     :class="item.is_active?'dot-active':'dot-inactive'"></i>

                </td>
                <td class="px-3">
                  <div class="text-secondary">
                    {{ item.start_date }} to {{ item.end_date ? item.end_date : 'N/A' }}
                  </div>
                  <div class="text-secondary">
                    <span class="badge badge-primary">{{ item.type.toUpperCase() }}</span>
                  </div>
                </td>
                <td>
                  <span class="badge" :class="item.exam_status ? item.exam_status =='completed'?'badge-success':'badge-warning' :'badge-warning'">
                    {{item.exam_status ? item.exam_status.toUpperCase() : 'Not Completed' }}
                  </span>
                </td>
                <td>
                     <span class="badge" :class="item.result_status ? item.result_status =='published'?'badge-success':'badge-danger' :'badge-danger'">
                       {{item.result_status ? item.result_status.toUpperCase() : "Pending" }}
                     </span>
                </td>
                <td class="pr-0 text-center">
                  <template>
                    <b-dropdown
                        size="sm"
                        variant="link"
                        toggle-class="custom-v-dropdown btn btn-clean btn-hover-light-primary btn-sm btn-icon"
                        no-caret
                        right
                        no-flip
                    >
                      <template v-slot:button-content>
                        <i class="ki ki-bold-more-hor"></i>
                      </template>
                      <!--begin::Navigation-->
                      <div class="navi navi-hover min-w-md-250px">
                        <b-dropdown-text tag="div" class="navi-item">
                          <a class="navi-link" @click="download(item.slug)">
                                  <span class="navi-icon">
                                      <i class="fas fa-download"></i>
                                  </span>
                            <span class="navi-text"> Download timeTable</span>
                          </a>
                        </b-dropdown-text>

                      </div>
                      <!--end::Navigation-->
                    </b-dropdown>
                  </template>
                </td>
              </tr>
              <tr v-if="assigned_exams.length == 0" >
                  <td colspan="5" class="text-center">
                    <strong>No items found</strong>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
<!--        <v-data-table
            :examLoading="isLoading"
            :headers="headers"
            :items-per-page="20"
            :items="assigned_exams"
        >

          <template v-slot:item.title="{ item }">
            {{ item.title }}
            <i class="fas fa-circle"
               :class="item.is_active?'dot-active':'dot-inactive'"></i>


          </template>
          <template v-slot:item.type="{ item }">
            {{ item.start_date }} to {{ item.end_date ? item.end_date : 'N/A' }}<br/>
            <span class="badge badge-primary">{{ item.type.toUpperCase() }}</span>


          </template>
          <template v-slot:item.is_active="{ item }">
                                                <span
                                                    :class="item.is_active?'badge badge-success':'badge badge-danger'">{{
                                                    item.is_active ? 'Active' : 'Inactive'
                                                  }}</span>
          </template>
          <template v-slot:item.exam_status="{ item }">
                                                      <span class="badge"
                                                            :class="item.exam_status ? item.exam_status =='completed'?'badge-success':'badge-warning' :'badge-warning'"
                                                      >{{
                                                          item.exam_status ? item.exam_status.toUpperCase() : 'Not Completed'
                                                        }}</span>
          </template>
          <template v-slot:item.result_status="{ item }">
                                                     <span class="badge"
                                                           :class="item.result_status ? item.result_status =='published'?'badge-success':'badge-danger' :'badge-danger'"
                                                     >{{
                                                         item.result_status ? item.result_status.toUpperCase() : "Pending"
                                                       }}</span>
          </template>
          <template v-slot:item.duration="{ item }">
            <a href="" @click.prevent="download(item.slug)">
              <span class="badge badge-success"> Download TimeTable</span>

            </a>
          </template>


        </v-data-table>-->
      </div>
    </div>
  </div>

</template>

<script>
    import { API_URL} from "@/core/config";
    import ExamService from "@/core/services/exam/ExamService";
    const examService = new ExamService();
    export default {
        name: "class-summary-exams",
        props: ['isLoading','class_id'],
        data() {
            return {
               /* headers: [
                    {text: 'Title', value: 'title', filterable: true, sortable: true},
                    {text: 'Date', value: 'type', filterable: true, sortable: true},
                    {text: 'Exam Status', value: 'exam_status', filterable: true, sortable: true},
                    {text: 'Result Status', value: 'result_status', filterable: true, sortable: true},
                    {text: 'Action', value: 'duration', filterable: true, sortable: true},

                ],*/
              assigned_exams:[],
              examLoading:false,
            }
        },
        methods: {
            download(slug) {
                let url = API_URL + "timetable-pdf"
                url = url + "?exam=" + slug
                // console.log(url)
                window.open(url)
                return;
            },
            getAssignedExams() {
              this.examLoading=true;
            examService
                .getExamByClassId(this.class_id)
                .then(response => {
                  this.assigned_exams = response.data.exams;
                })
                .catch(err=>{
                  // console.log(err)
                }).finally(()=>{
                    this.examLoading = false;
            })
          },
        },
      mounted() {
          this.getAssignedExams();
      }
    }
</script>

<style scoped>

</style>
